import {DataGridPro} from '@mui/x-data-grid-pro'
import {envBackHost, serverLocalName} from 'GLOBAL/envVariables'
import dayjs from 'dayjs'
import {axiosWithAuth} from 'helper/axiosWithAuth'
import fileDownload from 'js-file-download'
import CustomerTargetImageListModal from 'pages/common/CustomerTargetImageListModal'
import {customerLeakageColumnsBongHwa} from 'pages/customer/dataConfig/declearColumns'
import {customerLeakageFilter} from 'pages/customer/dataConfig/declearFilters'
import {customerLeakageRows} from 'pages/customer/dataConfig/declearRows'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import {resultAlert} from 'utils/CustomAlert/Alert'
import {getNewLeakList, getNewLeakListCount} from 'utils/apiCalling/api'

import {leakModelHandler} from 'utils/const/globalController'
import CustomPagination from 'utils/designSytem/CustomPagination'
import MeterariumPageLayout from 'utils/designSytem/MeterariumPageLayout'
import {imageDetailModalClose, imageDetailModalOpen, scrollTop} from 'utils/func/justUtils'
import {customerLeakageFilterType, getLeakListCallType} from 'utils/interface/customerType'
import {reduxType} from 'utils/interface/reduxType'
import {toolTipText} from 'utils/toolTips/toolTipText'
import {LeakDetailModal} from '../modules/LeakDetailModals'
import CustomerStatusTargetImageListModal from 'pages/common/CustomerStatusTargetImageListModal'

const CustomerLeakage = (props: any) => {
  /*********************************************************************
   * 1. Init Libs
   *********************************************************************/
  const leakOptionsDataInit: any = {
    officeName: '',
    leakUseCycle: '',
    leakUseStandard: '',
    leakUseUnit: '',
  }
  const customerInfoFilter = {
    searchOption: {
      customerNumber: false,
      customerName: false,
      address: false,
      managerName: false,
      memo: false,
      serialNumber: false,
      installerName: false,
    },
    searchData: '',
    deviceStatus: 'all',
    efosStatus: 'all',
    recognizedType: 'all',
    deviceType: 'all',
    batteryStatus: 'all',
    rowPerPage: 30,
    page: 1,
  }
  const officeInfo = useSelector((state: reduxType) => state.officeInfo)
  const cooperInfo = useSelector((state: reduxType) => state.cooperInfo)
  /*********************************************************************
   * 2. State settings
   *********************************************************************/
  const [pageSize, setPageSize] = useState<number>(10)
  const [leakInfo, setLeakInfo] = useState<any>()
  const [totalCount, setTotalCount] = useState<number>(0)
  const [listLoading, setlistLoading] = useState<boolean>(false)
  const [countLoading, setCountLoading] = useState<boolean>(true)
  const [leakCount, setLeakCount] = useState<number>(0)
  const [filter, setFilter] = useState<any>({
    ...customerLeakageFilter,
    flag: false,
  })
  const [deviceDetailData, setDeviceDetailData] = useState<any>()
  const [imageDetailOpen, setImageDetailOpen] = useState<boolean>(false)
  const [leakOptionsData, setLeakOptionData] = useState<any>(leakOptionsDataInit)
  const [leakModalOpen, setLeakModalOpen] = useState<boolean>(false)
  const [shouldCallApi, setShouldCallApi] = useState<boolean>(false)
  /*********************************************************************
   * 3. Handlers
   *********************************************************************/
  const openImageDetailModal = () => imageDetailModalOpen(setImageDetailOpen)
  const closeImageDetailModal = () => imageDetailModalClose(setImageDetailOpen)

  const totalCountCall = () => {
    const checkBusan = String(officeInfo.value).slice(0, 2) === '13'
    let selectedFilter = filter
    if (checkBusan) {
      selectedFilter = {
        ...filter,
        searchOption: {
          customerNumber: true,
          // customerNumber:
          // !filter.searchOption.customerNumber && !filter.searchOption.managerName
          // ? true
          // : filter.searchOption.customerNumber,
          // managerName:
          // !filter.searchOption.customerNumber && !filter.searchOption.managerName
          // ? true
          // : filter.searchOption.managerName,
        },
      }
    }

    getNewLeakListCount(officeInfo, cooperInfo, selectedFilter, {
      success: (res: getLeakListCallType) => {},
      fail: (err: any) => {
        console.log(err)
      },
      loading: (loading: boolean) => {
        setCountLoading(loading)
        if (!listLoading) {
          setlistLoading(loading)
        }
      },
      count: (count: number) => {
        setLeakCount(count)
      },
    })
  }

  const getLeakListCall = () => {
    const checkBusan = String(officeInfo.value).slice(0, 2) === '13'
    if (checkBusan) {
      {
        totalCount == 0 &&
          axiosWithAuth()
            .get(
              `${envBackHost}/${officeInfo?.value === 'yit' ? 'all' : officeInfo?.value}/${
                cooperInfo?.value
              }/customer/info`,
              {
                params: customerInfoFilter,
              }
            )
            .then((res) => {
              setTotalCount(res.data.count)
            })
      }
    } else {
      {
        totalCount == 0 &&
          axiosWithAuth()
            .get(
              `${envBackHost}/${officeInfo?.value === 'yit' ? 'all' : officeInfo?.value}/${
                cooperInfo?.value
              }/customer/overview`,
              {
                params: customerInfoFilter,
              }
            )
            .then((res) => {
              setTotalCount(res.data.count)
            })
      }
    }

    getNewLeakList(officeInfo, cooperInfo, filter, {
      success: (res: getLeakListCallType) => {
        setLeakInfo(res)
      },
      fail: (err: any) => {
        console.log(err)
      },
      loading: (loading: boolean) => {
        setlistLoading(loading)
      },
    })
  }
  const excelDownLoad = (params: customerLeakageFilterType) => {
    getDownloadExcel(params)
  }

  const getDownloadExcel = async (params: customerLeakageFilterType) => {
    await toast
      .promise(
        axiosWithAuth()
          .get(`${envBackHost}/${officeInfo?.value}/${cooperInfo?.value}/customer/leak/refactoring/v3/excel`, {
            params: params,
            responseType: 'blob',
          })
          .then(async (res) => {
            await resultAlert({resultCode: 0})
            fileDownload(res.data, `${officeInfo?.label}_${filter.date}_누수_의심_수용가.xlsx`)
          })
          .catch(async (e) => {
            await resultAlert({resultCode: 400})
          }),
        {
          pending: '다운로드 중입니다.',
        },
        {
          position: 'top-center',
          autoClose: 1000,
          className: 'fs-3  fw-bold',
          style: {width: '400px'},
        }
      )
      .catch(async (e) => {
        await resultAlert({resultCode: 400})
      })
  }

  const getOfficeDetailInfo = async () => {
    if (officeInfo.value !== 'yit') {
      axiosWithAuth()
        .get(`${envBackHost}/office/${officeInfo.value}`)
        .then((res: any) => {
          let response = res.data.res[0]
          setLeakOptionData({
            ...leakOptionsData,
            officeName: response.officeName,
            leakUseCycle: response.officeCustomerTypeModel[0].leakUseCycle,
            leakUseStandard: response.officeCustomerTypeModel[0].leakUseStandard,
            leakUseUnit: response.officeCustomerTypeModel[0].leakUseUnit,
            leakModalOpen: leakModalOpen,
            setLeakModalOpen: setLeakModalOpen,
            excelDownLoad: excelDownLoad,
          })
        })
    }
  }

  const columns: any = customerLeakageColumnsBongHwa(
    filter,
    openImageDetailModal,
    setDeviceDetailData
  )

  const rows = customerLeakageRows(leakInfo)

  const searchCall = () => {
    getLeakListCall()
    totalCountCall()
  }

  const searchHandler = () => {
    setFilter((prev: any) => ({...prev, page: 1}))
    setShouldCallApi(true)
  }

  useEffect(() => {
    if (shouldCallApi) {
      searchCall()
      setShouldCallApi(false)
    }
  }, [filter, shouldCallApi])

  useEffect(() => {
    scrollTop()
    getLeakListCall()
    if (leakModelHandler(serverLocalName, officeInfo.value) === '2') {
      getOfficeDetailInfo()
    }
  }, [officeInfo, cooperInfo, filter.date, filter.rowPerPage, filter.page])

  useEffect(() => {
    totalCountCall()
  }, [filter.date, officeInfo, cooperInfo])

  return (
    <>
      <MeterariumPageLayout
        headerDescription={toolTipText.customerLeakage.description}
        tooltipText={toolTipText.customerLeakage.text}
        filter={filter}
        id={'customer-leakage'}
        setFilter={setFilter}
        searchCallback={searchHandler}
        total={totalCount}
        errorCount={leakCount}
        hideSearch={true}
        control={['selectDate']}
        actions={['leak']}
        date={[{date: dayjs().format('YYYYMMDD')}]}
        asValue={leakOptionsData}
        searchOptions={[]}
        checkData={null}
        onDelete={null}
        onCancel={null}
        setTypeName={null}
        loading={countLoading && listLoading ? true : false}
      >
        <DataGridPro
          rows={rows}
          columns={columns}
          rowHeight={300}
          disableColumnMenu
          loading={listLoading}
          autoHeight={true}
          paginationMode={'server'}
          hideFooterPagination={true}
          pagination={true}
          hideFooter={true}
          sx={{
            '& .MuiDataGrid-cell:focus': {
              outline: 'none',
            },
          }}
        />
        <CustomPagination filter={filter} setFilter={setFilter} totalCount={leakCount} />
      </MeterariumPageLayout>
      <LeakDetailModal
        leakOption={leakOptionsData}
        filter={filter}
        open={leakModalOpen}
        setOpen={setLeakModalOpen}
      />
      <CustomerStatusTargetImageListModal
        data={deviceDetailData}
        open={imageDetailOpen}
        onClose={closeImageDetailModal}
      />
    </>
  )
}
export default CustomerLeakage
